import { replace } from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import $ from 'jquery';
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';

const MyEsCurrencyInputDivBlock = styled.div`
    position: relative;

    .pblock {
        position: relative;
        margin-bottom: 7px;
    }

    .won {
        font-size: 22px;
        font-weight: 500;
    }

    .line {
        height: 1px;
        border-bottom: solid 1.5px #333333;
    }

    .kwon {
        font-size: 12px;
        line-height: 1.83;
        //text-align: right;
        color: #79b88a;
        width: 100%;
        padding-right: 10px;
        margin-top: 10px;
        padding-left: 10px;
        height: 18px;
    }

    .reset {
        display: ${props => props.displaybtn || 'none'};
        float: right;
        margin-right: 8px;
        margin-top: 8px;
        width: 23px;
        height: 23px;
        background: url(/assets/images/icon/my-close.svg) center center/auto no-repeat;
    }

    .btn {
        height: 24px;
        padding: 3px 12px;
        border-radius: 12px;
        background-color: #f4f4f4;
        
        margin-bottom: 15px;

        font-size: 12px;
        font-weight: 500;
        //line-height: 1.83;
        color: #999999;

        .manwon {
            font-weight: 400;
        }
    }

    .btn-right {
        margin-right: 15px;
    }

    .btn-container {
        padding-left: 10px;
    }
`;

const CurrencyInputDivBlock = styled.div`
    height: ${props => props.height || '40px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    //width: ${props => props.width || 'fit-content'};
    width: fit-content;
    float: ${props => props.float || 'left'};
`;

const CurrencyInputBlock = styled.input`
    height: ${props => props.height || '40px'};
    //width: ${props => props.width || '20px'};
    //padding: 0 32px 0 15px;
    border: ${props => props.border||'1px solid #ccc'};//1px solid #ccc;
    border-radius: 4px;
    text-align: ${props => props.textAlign || 'right'};
    font-size: ${props => props.fontSize || '14px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    font-weight: ${props => props.fontWeight || '700'};

    &:focus {
        border: ${props => props.focusBorder};
        outline: 0
    }

    ::-webkit-input-placeholder {
        color: #ccc
    }

    ::-moz-placeholder {
        color: #ccc
    }

    ::-ms-input-placeholder {
        color: #ccc
    }

    ::placeholder {
        color: #ccc
    }
    :focus {
        outline: 0
    }
`;

const HideSpanBlock = styled.span`
    height: 40px;
    //width: ${props => props.width || '10px'};
    padding: 0 32px 0 15px;
    border: ${props => props.border||'1px solid #ccc'};//1px solid #ccc;
    border-radius: 4px;
    text-align: ${props => props.textAlign || 'right'};
    font-size: ${props => props.fontSize || '14px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    font-weight: ${props => props.fontWeight || '700'};

    display:none;
    white-space:pre;
`;

const MyEsCurrencyInputComp = ({ float, height, maxLength, placeholder,
    marginBottom, marginTop, marginLeft, marginRight,
    marginInnerTop, onBlur, onFoucs,
    onChange, disabled, fontSize,
    width,
    inputRef, textAlign, fontWeight, firstValue = 0, border, focusBorder }) => {

    const [strPrice, setStrPrice] = useState('');
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(0);
    const [price, setPrice] = useState(0);
    const history = useHistory();
    
    var setting = {
        maxLength: maxLength,
        placeholder: placeholder,
        marginTop: marginInnerTop,
        focusBorder: focusBorder||'1px solid #ffc742',
        disabled: disabled,
        fontSize: fontSize,
        textAlign: textAlign,
        fontWeight: fontWeight,
        width: width,
        border:border
    }
    const { esMyBudget} = useSelector(
        ({ esMyReducer }) => ({
            esMyBudget: esMyReducer.esMyBudget,
        })
    );

    useEffect(() => {

        if(strPrice.length > 0) {
            inputRef.current.selectionStart = start;
            inputRef.current.selectionEnd = end;
        }

    }, [start, strPrice])

    useEffect(() => {
        if(firstValue*1 > 0) {
            setStrPrice(Number(firstValue.toFixed(1)).toLocaleString());
        }

        $('#hide').text('0'); 
        $('#txt').width($('#hide').width());
    }, [])

    useEffect(() => {
        if(strPrice) {
            if(strPrice.length===0){
                $('#hide').text('0'); 
            } else {
                $('#hide').text($('#txt').val());
            }
            
            //console.log("width = " + $('#hide').width())
            $('#txt').width($('#hide').width()+1);
        } else {
            $('#hide').text('0'); 
            //console.log("width = " + $('#hide').width())
        }

        if(strPrice === "0") {
            setStrPrice('')
        } 
    }, [strPrice])

    useEffect(() => {
        if(/* history.action === 'POP' && */ esMyBudget*1>0){
            
            let numPrice = esMyBudget;
            setStrPrice(Number(numPrice.toFixed(1)).toLocaleString());
            setPrice(numPrice);

            if (onChange != null && onChange !== undefined) {
                onChange(numPrice);
            }
        } 
    }, [esMyBudget]);

    const handleInputChange = (e) => {

        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        const beforeLength = e.target.value.length;
        let afterLength = 0;
        let margin = 0;

        // remove comma
        let numPrice = replace(e.target.value, /,/g, "");
        numPrice = numPrice * 1;


        // 문자 입력 방지 , 음수 방지
        if (isNaN(numPrice) || numPrice < 0) {
            return;
        }

        // Display Comma 
        setStrPrice(Number(numPrice.toFixed(1)).toLocaleString());

        afterLength = Number(numPrice.toFixed(1)).toLocaleString().length;

        // Start 위치가 Before Length 와 같으면 +1
        if (start === beforeLength || afterLength > beforeLength) {
            ++margin;
        } else if (beforeLength > afterLength) {
            --margin;
        }

        setStart(start + margin);
        setEnd(end + margin);
        setPrice(numPrice);

        if (onChange != null && onChange !== undefined) {
            onChange(numPrice);
        }
    }

    const handeBlur = () => {
        // console.log("handeBlur ++++++++");
        if (onBlur != null && onBlur !== undefined) {
            onBlur();
        }
    }

    const handleFocus = () => {
        // console.log("handleFocus ------>")
        if (onFoucs != null && onFoucs !== undefined) {
            onFoucs();
        }
    }

    const handleReset = () => {
        setPrice(0);
        setStrPrice("0");
        if (onChange != null && onChange !== undefined) {
            onChange(0);
        }
    }

    const handleAddPrice = (addPrice) => {
        let numPrice = price + addPrice;
        setStrPrice(Number(numPrice.toFixed(1)).toLocaleString());
        setPrice(numPrice);

        if (onChange != null && onChange !== undefined) {
            onChange(numPrice);
        }
    }

    const viewKorean = (num2) =>{ 
        var hanA = new Array("","일","이","삼","사","오","육","칠","팔","구","십"); 
        var danA = new Array("","십","백","천","","십","백","천","","십","백","천","","십","백","천"); 
        var result = ""; 
        var num = num2.toString();
        //console.log("viewKorean = " + num.length);
        for(var i=0; i<num.length; i++) { 
            var str = ""; 
            var han = hanA[num.charAt(num.length-(i+1))]; 
            if(han != "") str += han+danA[i]; 
            if(i == 4) str += "만"; 
            if(i == 8) str += "억"; 
            if(i == 12) str += "조"; 
            result = str + result; 
        } 
        
        if(num != 0) result = result + "원"; 
        
        return result ; 
    }
    
    return (
        <MyEsCurrencyInputDivBlock displaybtn={price>0? "block":"none"}>
            <HideSpanBlock {...setting} id="hide"></HideSpanBlock>
            <div className="pblock clearfix">
                <CurrencyInputDivBlock
                    float={float}
                    height={height}
                    width={width}
                    marginTop={marginTop}
                    marginBottom={marginBottom}
                    marginLeft={marginLeft}
                    marginRight={marginRight}
                    displaybtn={price>0? "block":"none"}>
                    <CurrencyInputBlock
                        {...setting}
                        ref={inputRef}
                        value={strPrice}
                        onChange={handleInputChange}
                        onBlur={() => { handeBlur() }}
                        onFocus={() => { handleFocus() }}
                        inputMode='decimal' 
                        id="txt"
                    />
                </CurrencyInputDivBlock>
                <span className="won" style={{
                    float:'left', top: '3px', position: 'relative'
                }}>
                    원
                </span>
                <button className="reset" onClick={handleReset}></button>
                
            </div>
            <div className="line" />
            <div className="kwon">{viewKorean(price)}</div>
            <div className="btn-container margin_t-20">
                <button className="btn btn-right" onClick={()=>handleAddPrice(50000)}>+5<span className="manwon">만원</span></button>
                <button className="btn btn-right" onClick={()=>handleAddPrice(100000)}>+10<span className="manwon">만원</span></button>
                <button className="btn btn-right" onClick={()=>handleAddPrice(1000000)}>+100<span className="manwon">만원</span></button>
                <button className="btn" onClick={()=>handleAddPrice(2000000)}>+200<span className="manwon">만원</span></button>
            </div>
        </MyEsCurrencyInputDivBlock>
    );
};

export default MyEsCurrencyInputComp;